import { Grid, Typography } from '@material-ui/core';
import { useState, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { editView, deleteView, resetView } from '../../../store/views/actions';
import { getViews } from '../../../store/views/selectors';
import DeleteCancel from '../../atoms/buttons/DeleteCancel';
import { handleSnackBar, toggleRightDrawer, setCurrentViewId, setReRender, invokePostService, setCodeEditStatus, setFocusElement } from '../../../store/global/actions';
import { getRightDrawerStatus, getCodeEditStatus, getElementOnFocus } from '../../../store/global/selectors';
import { useHistory } from 'react-router-dom';
import { getDetailsFromUrl } from '../../../services/blueprint';

const DeleteViewEntity = ({ id, parentID, type, onClose, dashboardInstance   }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { slug, blueprintId, entityId } = getDetailsFromUrl();

    const selectedView = useSelector(getViews);
    const rightDrawerStatus = useSelector(getRightDrawerStatus);
    const codeEditStatus = useSelector(getCodeEditStatus);
    const elementOnFocus = useSelector(getElementOnFocus);

    const [isDeleting, setIsDeleting] = useState(false);

    const uiType = type === 'section' ? 'Section' : type === 'view' ? 'View' : type === 'field' ? 'Field' : 'Widget';


    const deleteItem = () => {
        setIsDeleting(true);
        if (type === 'view' && selectedView) {
            dispatch(deleteView(selectedView)).then((response) => {
                setIsDeleting(false);
                onClose();
                if (codeEditStatus) {
                    dispatch(setCodeEditStatus(false));
                }
                if (response.status === true) {
                    dispatch(resetView());
                    if (response.nextView == null) {
                        history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                    } else {
                        dispatch(setCurrentViewId(response.nextView._id));
                        history.push(`/blueprint/${slug}/${blueprintId}/view/${response.nextView._id}`);
                    }
                    dispatch(setReRender());
                    dispatch(handleSnackBar({ open: true, message: "View deleted", severity: 'success' }));
                } else {
                    if (response.code === 255) {
                        history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                        dispatch(setReRender());
                        if (rightDrawerStatus == true) dispatch(toggleRightDrawer());
                    }
                    return;
                }
            });
        }

        if(type === 'section'){
            const updatedSection = dashboardInstance.removeSection(id);
            const updatedSchema = {
                ...selectedView,
                view_schema: updatedSection
            };
            if (rightDrawerStatus === true && elementOnFocus?.id === id){
                dispatch(toggleRightDrawer());
            }else{
                if (elementOnFocus?.id === id) dispatch(setFocusElement({}));
            } 

            dispatch(invokePostService('updateView', { view: updatedSchema }, [entityId])).then((response) => {
                setIsDeleting(false);
                onClose();
                dispatch(editView(updatedSchema));
            });
        }
    };

    return (
        <Grid container direction={'row'} spacing={3}>
            <Grid item xs={12}>
                <Fragment>
                    <Typography>{`Are you sure you want to delete the ${uiType}?`} </Typography>
                </Fragment>
            </Grid>
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <DeleteCancel onDelete={deleteItem} onCancel={onClose} disableButton={isDeleting} content={isDeleting ? 'Deleting..' : 'Delete'} />
            </Grid>
        </Grid>
    );
};

export default DeleteViewEntity;
